import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import _ from 'lodash';
import classNames from 'classnames';
import Button from "../../components/Button/Button";
import FormActions from "../../components/FormActions/FormActions";
import { withFirebase } from "../../components/Firebase/Firebase";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { withPrismic } from "../../components/Prismic/Prismic";
import RichText from "../../components/RichText/RichText";
import VideoUpload from "../../components/VideoUpload/VideoUpload";

const requiredChecks = {
  studentEntry : <span>We have a completed <a href="https://prismic-io.s3.amazonaws.com/videosforchange%2Fba210d36-493c-426c-bb2b-2d0f0deb0c6b_team+member+entry+form_june2019.pdf" target="_blank" rel="noopener noreferrer">Team Member</a> form for each member of our filmmaking team (signed by parent/guardian)</span>,
  talentRelase : <span>We have a signed <a href="https://prismic-io.s3.amazonaws.com/videosforchange%2F8fd29d25-36d8-4a83-8590-998259680c11_talent+release+forms_june+2019.pdf" target="_blank" rel="noopener noreferrer">Talent Release</a> form for any other people that appear in our video even if they’re not that talented!</span>,
  videoFormat : <span>Our video file has been renamed with our unique id code provided below and is in one of the following formats (MP4, MOV, MPEG4, AVI, WMV or WebM)</span>,
  competitionRequirements : <span>We confirm that we have met all the requirements for the competition and only copyright free content has been used</span>,
  originalWork : <span>Our video entry is our original work created in 2019 and meets the requirements for the competition</span>
}

class Stage5 extends Component {
	constructor(props) {
		super(props);
		this.state =  {
			copied: false,
      inputs: {}
		}
    _.each(requiredChecks, (label, name) => {
      let inputs = this.state.inputs;
      inputs[name] = false;
      this.setState({inputs:inputs});
    });

    this.handleInputEvent = this.handleInputEvent.bind(this);
    this.checkboxClasses = this.checkboxClasses.bind(this);
  }

	shortId = () => {
		return this.props.id && this.props.id.split(/[-]+/) && this.props.id.split(/[-]+/).pop();
	}
	
	continue = async () => {
		await this.props.methods.updateEntryStage(this.props.id, 6);
	};
	
	previous = async () => {
		await this.props.methods.updateEntryStage(this.props.id, 2);
    this.props.history.push(`/competition/${this.props.slug}/enter/${this.props.id}`);
	};

  handleInputEvent = (e, key) => {
    let value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    // console.log('setting to ',key, value, e.target.checked);
    this.setState({
      inputs: {
        ...this.state.inputs,
        [key]: value
      }
    });
    // console.log(this.state.inputs);
  };

  isValid = () => {
    let isValid = true;
    if(!this.state.inputs) return false;
    _.each(this.state.inputs, (input, i) => {
      if(!input) isValid = false;
    })
    return isValid;
  }

  checkboxClasses = (input) => {
    return classNames({
      'checkbox': true,
      "-checked": this.state.inputs[input],
    });
  }

  renderCheckboxes = () => {

    let checkboxes = [];
    _.each(requiredChecks, (label, name) => {
      checkboxes.push(<div className={this.checkboxClasses(name)} key={name}>
				<label htmlFor={name} >
					<input type="checkbox" name={name} id={name} checked={this.state.inputs[name]} onChange={e => this.handleInputEvent(e, name)} />
          {label}</label>
			</div>)
    });
    return checkboxes;
  }

	render() {

		if(!this.props.terms) return null;

		return (
			<div>
			
			<RichText content={this.props.terms.stage_5_0} />

			<div className="checklist-questions">
				{this.renderCheckboxes()}
			</div>

			<RichText content={this.props.terms.stage_5} />

			<CopyToClipboard text={this.shortId()}
			onCopy={() => this.setState({copied: true})}>
				<h3 className="-copyable" title="Copy to clipboard"><strong>{this.shortId()}</strong><i className="icon-clipboard" style={{fontSize: 29, color: '#c4c4d4', float: 'right'}}/></h3>
			</CopyToClipboard>
			{this.state.copied && <p className="fineprint -copied">Copied to clipboard!</p>}
			{/* <p className="-fineprint">(Followd by your file extension, eg {this.shortId()}.mov, {this.shortId()}.mp4, etc)</p> */}
      <RichText content={this.props.terms.stage_5_after} />
			<FormActions
			left={
				<div>
				<Button onClick={this.previous}>Back</Button>
				</div>
			}
			right={
				<div>
				<VideoUpload disabled={!this.isValid()} />
				</div>
			}
			/>
			</div>
		);
	}
}

export default withRouter(withPrismic(withFirebase(Stage5)));



// WEBPACK FOOTER //
// ./src/pages/CompetitionEnter/Stage5.js